import React, { useState } from 'react'
import './AddMenuPage.css'
import PartySummary from './custom-comp/PartySummary'
import PartySetup from './custom-comp/PartySetup'
import MenuItemCard from './custom-comp/MenuItemCard';

export default function AddMenuPage() {

      const [selectedItems, setSelectedItems] = useState([]);

    return (
        <div className='Add-menu-page'>
            <PartySummary selectedItems={selectedItems} />
            <PartySetup selectedItems={selectedItems} setSelectedItems={setSelectedItems} />
            {/* <MenuItemCard  item, image, isSelected, onToggle, isDisabled, hideCheckbox,  /> */}
        </div>
    )
}
